<template>
	<transition name="fade">
		<vx-card v-if="activeItem === 0">
			<div slot="no-body" class="tabs-container px-6 pt-6">
				<div class="tab-text">
					<upload-file-form
						v-if="uploadfileCreatePermission && showUploadFile"
						ref="UploadFileForm"
						@uploadStatusEmit="uploadStatusEmit"
					/>

					<set-equivalences
						v-else-if="uploadfileCreatePermission && showSetEquivalence"
						ref="SetEquivalences"
						@closeEquivalenceEmit="closeEquivalenceEmit"
						@cancelEquivalenceEmit="cancelEquivalenceEmit"
					></set-equivalences>

					<not-permission v-else></not-permission>
				</div>
			</div>
		</vx-card>
	</transition>
</template>

<script>
import UploadFileForm from "./UploadFileForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import UploadedFile from "@/models/UploadedFile.js";
import SetEquivalences from "./SetEquivalences.vue";

export default {
	components: {
		UploadFileForm,
		NotPermission,
		SetEquivalences,
	},
	data() {
		return {
			activeTab: 0,
			activeItem: 0,
			uploadFile: new UploadedFile({}),
		};
	},
	computed: {
		uploadfileReadPermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_R");
		},
		uploadfileCreatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_C");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		activeTabName() {
			if (this.uploadFile.id > 0) {
				return this.$t("ManualData.ManageError");
			} else {
				return this.$t("Reports.History");
			}
		},
		showSetEquivalence() {
			return this.$store.state.uploadFile.showSetEquivalence;
		},
		showUploadFile() {
			return this.$store.state.uploadFile.showUploadFile;
		},
	},
	methods: {
		selectedUploadFileEmit(object) {
			this.uploadFile = new UploadedFile(object);
		},
		uploadStatusEmit(val) {
			if (val) {
				this.$store.commit("uploadFile/SET_SHOW_EQUIVALENCES", true);
				this.$store.commit("uploadFile/SET_SHOW_UPLOAD_FILE", false);
			}
		},
		closeEquivalenceEmit() {
			this.cancelEquivalenceEmit();
			setTimeout(() => {
				this.$refs.UploadFileForm.showSuccessUpload();
			}, 200);
		},
		cancelEquivalenceEmit() {
			this.$store.commit("uploadFile/SET_SHOW_EQUIVALENCES", false);
			this.$store.commit("uploadFile/SET_SHOW_UPLOAD_FILE", true);
			this.$store.commit("uploadFile/SET_EQUIVALENTS", null);
			this.$store.commit("uploadFile/SAVE_UPLOAD", null);
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.uploadFile = new UploadedFile({});
			}
		},
	},
	created() {
		const active_tab = this.$route.params.active_tab;
		if (active_tab) {
			this.activeTab = active_tab;
		}
	},
	beforeDestroy() {
		this.cancelEquivalenceEmit();
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.fade-enter-active {
	transition: opacity 0.7s;
}
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
